import {
    Container,
    Grid,
    Center, Group, SegmentedControl, useMantineTheme,
} from '@mantine/core';

import MobileRender from "./mobile-render/MobileRender";
import DefaultSidebar from "./left-sidebar/DefaultSidebar";
import {useViewportSize} from "@mantine/hooks";

import Header from "./Header";
import OnboardModal from "./onboard/OnboardModal";
import RightSidebar from "./right-sidebar/RightSidebar";
import {IconEdit, IconEye} from "@tabler/icons-react";
import {useDispatch, useSelector} from "react-redux";
import {setViewMode} from "../../features/preview/viewModeSlice";

const Dashboard = () => {

    const theme = useMantineTheme();
    const {height, width} = useViewportSize();
    const dispatch = useDispatch();

    const {viewMode} = useSelector(state => state.viewMode)


    const handleViewMode = (value) => dispatch(setViewMode(value))


    return (
        <>
            <Header/>
            <Container fluid px={0} pr={1} bg="var(--mantine-color-gray-light)" h={height - 42}>
                <Grid gutter={0} h="inherit" justify="center">
                    <Grid.Col span="auto">

                        <DefaultSidebar />

                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Center maw={`100%`} h={`90vh`}>

                            <MobileRender />



                        </Center>
                        {/*<Group justify="center">
                            <SegmentedControl
                                bg="gray.3"
                                color={theme.primaryColor}
                                value={viewMode}
                                onChange={(value) => handleViewMode(value)}
                                data={[
                                    {
                                        value: 'preview',
                                        label: (
                                            <Center style={{ gap: 10 }}>
                                                <IconEye size={16} />
                                                <span>Preview</span>
                                            </Center>
                                        ),
                                    },
                                    {
                                        value: 'edit',
                                        label: (
                                            <Center style={{ gap: 10 }}>
                                                <IconEdit size={16} />
                                                <span>Edit</span>
                                            </Center>
                                        ),
                                    }
                                ]}
                            />
                        </Group>*/}
                    </Grid.Col>
                    <Grid.Col span={3} pos="relative">

                        <RightSidebar />

                    </Grid.Col>
                </Grid>
            </Container>

            <OnboardModal/>

        </>
    );
}

export default Dashboard;